import { SignatureData } from "../../service/forms/config-generics/signature";

export function getSignatureSVGLines({ signed }: SignatureData) {
    return [{ src: signed }];
}